import { IProductFootnote } from '@models/IProductFootnote';
import SoftLoadWrapper from '@molecules/SoftLoadWrapper/SoftLoadWrapper';
import useProductPageContentStore from '@state/ProductPageStore';

const ProductFootnote = (props: IProductFootnote) => {
  const { title, text } =
    useProductPageContentStore().productPageContent?.productFootnote || props;

  if (!title && !text) {
    return null;
  }

  return (
    <section className="component-padding bg-grey-700">
      <SoftLoadWrapper>
        <div className="py-10 text-grey-400">
          <div className="container grid gap-y-3 xl:grid-cols-12">
            {title && (
              <div className="small-text bold xl:col-span-6 xl:col-start-2">
                {title}
              </div>
            )}
            {text && (
              <div
                className="small-text content-area xl:col-span-6 xl:col-start-2"
                dangerouslySetInnerHTML={{ __html: text }}
              />
            )}
          </div>
        </div>
      </SoftLoadWrapper>
    </section>
  );
};

export default ProductFootnote;
